import { useGetVoyageArrivals } from 'api-hooks/voyage/query';
import { FlipCruiseIcon } from 'assets/images/svg';
import IconBox from 'components/commons/icon-box';
import Input from 'components/elements/field';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { Oval } from 'react-loader-spinner';
import color from 'styles/color';

interface Props {
  name: string;
  required?: boolean;
  disabled?: boolean;
  departureCode: string;
}

export default function ArrivalVoyageSelectInput(props: Props) {
  const { departureCode: d, ...rest } = props;
  const { t } = useTranslation();
  const { data, isFetching } = useGetVoyageArrivals({
    params: { d },
  });
  const options = React.useMemo(() => {
    if (data?.data) {
      return data.data.map((item) => ({ value: item.code, label: item.name }));
    }
    return [];
  }, [data?.data]);

  return (
    <Input
      {...rest}
      type="select"
      label={t('common:to')}
      placeholder={t('common:select_destination_port')}
      noDataMessage={t('common:select_the_port_of_origin_first')}
      options={options}
      onRenderLeft={
        isFetching ? (
          <IconBox css={{ pl: 16 }}>
            <Oval
              color={color.primary}
              secondaryColor={color.primary5}
              width={24}
              height={24}
            />
          </IconBox>
        ) : (
          <IconBox css={{ ml: 16 }} tabIndex={-1}>
            <FlipCruiseIcon size={24} />
          </IconBox>
        )
      }
    />
  );
}
